import { useQuery } from "@tanstack/solid-query";
import axios from "axios";
import { COUNTRIES_BASE_URL } from "../constants.ts";
import { LanguageCode } from "../state/i18n.tsx";

type Country = {
  alpha2Code: string;
  name: string;
  callingCode: string;
  translations: Record<LanguageCode, string>;
};

type CountriesResponse = {
  current?: Country;
  countries: Country[];
};

export type Countries = {
  current?: Country;
  countries: Country[];
};

const CountriesService = {
  getCountries: () =>
    useQuery<Countries>(() => ({
      queryKey: ["countries", "v2"],
      queryFn: async () => {
        const { data } = await axios.get<CountriesResponse>(COUNTRIES_BASE_URL + "/v2");
        return { current: data.current, countries: data.countries };
      },
      staleTime: Infinity,
    })),
};

export default CountriesService;
